module.exports = __webpack_public_path__ + "assets/src/style/img/svg/logo-here-now-friesland.svg?62aa68ae845bbf9b3d307fcebd409a6f";